import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { useSiteSettings } from '../hooks/useSiteSettings';
import './AdPopup.css';

const POPUP_REMIND_KEY = 'ad_popup_remind_until';

const resolveImage = (src) => {
  if (!src) return '';
  if (src.startsWith('http') || src.startsWith('data:')) return src;
  return `${process.env.REACT_APP_API_URL || ''}${src}`;
};

const AdPopup = () => {
  const {
    popup_enabled, popup_image, popup_text,
    popup_duration_seconds, popup_remind_hours
  } = useSiteSettings();
  const [visible, setVisible] = useState(false);

  const enabled = popup_enabled === '1' || popup_enabled === true;
  const remindHours = parseInt(popup_remind_hours, 10);
  const safeRemindHours = !isNaN(remindHours) && remindHours > 0 ? remindHours : 24;
  const displaySeconds = parseInt(popup_duration_seconds, 10);
  const safeDisplaySeconds = !isNaN(displaySeconds) && displaySeconds > 0 ? displaySeconds : 5;

  useEffect(() => {
    if (!enabled) return;

    try {
      const remindUntil = localStorage.getItem(POPUP_REMIND_KEY);
      if (remindUntil && Date.now() < Number(remindUntil)) return;
    } catch (e) {
      /* ignore */
    }

    const showDelay = setTimeout(() => {
      setVisible(true);
      try {
        localStorage.setItem(POPUP_REMIND_KEY, String(Date.now() + safeRemindHours * 3600 * 1000));
      } catch (e) {
        /* ignore */
      }
    }, 1500);

    return () => clearTimeout(showDelay);
  }, [enabled, safeRemindHours]);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), safeDisplaySeconds * 1000);
    return () => clearTimeout(t);
  }, [visible, safeDisplaySeconds]);

  if (!enabled || !visible) return null;

  const image = resolveImage(popup_image || '');
  const text = (popup_text || '').trim();

  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      closable
      centered
      width={480}
      className="ad-popup-modal"
    >
      <div className="ad-popup">
        {image ? (
          <div className="ad-popup-image-wrap">
            <img src={image} alt={text || 'إعلان'} className="ad-popup-image" />
          </div>
        ) : (
          <div className="ad-popup-image-placeholder">
            <PictureOutlined />
          </div>
        )}
        {text && <div className="ad-popup-text">{text}</div>}
      </div>
    </Modal>
  );
};

export default AdPopup;